import { Injectable } from '@angular/core';
import { map,lastValueFrom } from 'rxjs';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { CommonApiService } from '../common.service';
import { MultiInvoice } from 'src/state/multi-invoice/state-models/multi-invoice';


@Injectable({
    providedIn: 'root'
})
export class MultiInvoiceApiService {
    constructor(
        private apollo: Apollo,
        private commonService: CommonApiService
    ) { }


    private multiInvoiceSearchQuery=`
    view(allocationScaniaUnit:$allocationScaniaUnit, from: $from, to: $to, paging: $paging, order: $order, filter: $filter) {
      list {
        chassisNumber
        productIndividualNumber
        country
        invoiceDate
        finalAssembly
        faDescription
        arReceive
        manualReceive
        totalInvoiceReceived
      }
      totalCount
      
    }`;

    exportMultiInvoice(variables?, fileName: string = null): Promise<any> {
      
          const query = gql`
            query multiInvoiceQuery($allocationScaniaUnit: Int, $from: DateTime, $to: DateTime) {
              multiInvoice {
                  search(allocationScaniaUnit:$allocationScaniaUnit, from: $from, to: $to) {
                    Chassis_No: chassisNumber
                    Product_individual_number: productIndividualNumber
                    Country: country
                    Invoice_date: invoiceDate
                    FinalAssembly: finalAssembly
                    FA_Description: faDescription
                    Total_invoice_received: totalInvoiceReceived
                    AR_Receive: arReceive
                    Manual_Receive: manualReceive
                      }
              }
            }`;
            
            return this.commonService.exportQuery(query, variables, fileName, true, 'multi invoice');
        }

        getMultiInvoiceList(variables?, forceRefetch: boolean = false): Promise<any> {
              const result$ =  this.apollo
                  .query<MultiInvoice[]>({
                      variables,
                      fetchPolicy: forceRefetch ? 'no-cache' : null,
                      query: gql`
                      query multiInvoiceQuery($allocationScaniaUnit: Int, $from: DateTime, $to: DateTime, $paging: Paging, $order:String, $filter:String) {
                        multiInvoice {
                          
                            ${this.multiInvoiceSearchQuery}
                          
                        }
                      }`
                  })
                  .pipe<MultiInvoice[]>(
                                   map((result: any) => {
                                    
                          return result?.data?.multiInvoice?.view;
                      })
                    );
                      
                    return lastValueFrom(result$);  
          }
        }